import { render, staticRenderFns } from "./ProductComponentsInfoList.vue?vue&type=template&id=6f7a1991&scoped=true&"
import script from "./ProductComponentsInfoList.vue?vue&type=script&lang=js&"
export * from "./ProductComponentsInfoList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7a1991",
  null
  
)

export default component.exports